<template>
    <table class="table">
        <tr v-for="sport_event in sport_events">
            <td>{{ sport_event.scheduled }}<br>({{ sport_event.status }})</td>
            
            <td v-for="competitor in sport_event.competitors">
                {{ competitor.name }}<br>({{ competitor.qualifier}})
            </td>

            <td v-for="percentage in sport_event.consensus.bet_percentage_outcomes">
                <b>{{ percentage.name }} %</b>

                <table class="table">
                    <tr v-for="outcome in percentage.outcomes">
                        <td>
                            {{ outcome.type }}: {{ outcome.percentage }}
                            
                        </td>
                    </tr>
                </table>
            </td>

            <td v-for="line in sport_event.consensus.lines">
                <b>{{ line.name }}</b>

                <table class="table">
                    <tr v-for="outcome in line.outcomes">
                        <td>
                            {{ outcome.type }}: {{ outcome.odds }}
                            
                        </td>
                    </tr>

                    <tr v-if="line.spread">
                        <td>spread: {{ line.spread }}</td>
                    </tr> 
                    <tr v-if="line.total">
                        <td>spread: {{ line.total }}</td>
                    </tr> 
                </table>

                
            </td>
        </tr>
    </table>
</template>

<script>
export default {
    name: 'ConsensusLinesTable',
    props: {
        sport_events: ''
    }
}
</script>

